export const REDUX_GET_ATTENDANCE_SETTING = 'REDUX_GET_ATTENDANCE_SETTING'
export const REDUX_ = 'REDUX_'
